import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import DiagExchangeRegisterDatePickerBottomSheet from '@di-shared/features/diag/exchange/register/DiagExchangeRegisterDatePickerBottomSheet';

function DiagExchangeRegisterDatePickerBottomSheetPage() {
  const selectedDate = window.data.selectedDate as unknown as Date;
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={300}>
      <DiagExchangeRegisterDatePickerBottomSheet selectedDate={selectedDate} />
    </BottomSheetWebViewWrapper>
  );
}

export default DiagExchangeRegisterDatePickerBottomSheetPage;
